import { Typography } from "@material-ui/core";
import PropTypes from "prop-types";
import React from "react";
import { loanTypeIcons } from "../config";

export function LoanTypeIcon(props) {
  const { type, size } = props;
  const defaultSize = 34;
  const iconSize = size || defaultSize;
  const iconName = (type) => {
    return loanTypeIcons[type] || loanTypeIcons.undefined;
  };
  return (
    <div
      style={{
        marginRight: `${iconSize}px`,
        height: `${iconSize}px`,
        width: `${iconSize}px`,
      }}
    >
      <Typography color={"secondary"}>
        <i
          className={`icon-${iconName(type)} mr1`}
          style={{
            verticalAlign: "sub",
            fontSize: `${iconSize}px`,
            position: "absolute",
          }}
        />
      </Typography>
    </div>
  );
}

LoanTypeIcon.propTypes = {
  size: PropTypes.number,
  type: PropTypes.string.isRequired,
};
